// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3N5ao","footer":"ModalInfo_footer__MHYvf"};